import React, { FC, useEffect, useState } from 'react';

import { CountryService } from '../../../services/CountryService';
import { JCountryProps, JSelectOption } from '../../models';
import { JValueSelect } from './JValueSelect';
export const JCountry: FC<JCountryProps> = (props) => {
    const [options, setOptions] = useState<JSelectOption[]>([])

    useEffect(() => {
        CountryService.getCountries(props.extraOptions).then(countries => setOptions(countries?.map<JSelectOption>(country => ({
            value: country.isoCode2,
            svg: country.flag,
            label: country.name,
            title: country.name
        }))))
    }, [])

    return <JValueSelect {...props} options={options} searcheable />
}

